import type { MenuItemCustomActionWithUrlViewModel } from 'autogen/swagger/all';
import useIsClubMatasMember from 'hooks/user/useIsClubMatasMember';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import type { DefaultMenuItemProps } from '../types';
import DefaultMenuItem from './DefaultMenuItem';

type ClubMatasPlusMenuItemProps = {
    model: MenuItemCustomActionWithUrlViewModel;
    defaultProps: DefaultMenuItemProps;
};

export default function ClubMatasPlusMenuItem({
    model: { linkAction, text },
    defaultProps: { iconUrl, styling, id },
    ...restProps
}: ClubMatasPlusMenuItemProps) {
    const { isMatasPlusMember } = useIsClubMatasMember();

    if (isMatasPlusMember) return null;

    return (
        <DefaultMenuItem.Anchor
            anchorProps={{ action: linkAction, title: text }}
            iconUrl={iconUrl}
            styling={styling}
            onClick={() => {
                GA4Tracking({
                    eventName: 'link_click',
                    context: 'menu',
                    category: 'navigation',
                    eventParams: [
                        { param_name: 'link_type', param_value: 'internal' },
                        { param_name: 'list_name', param_value: text },
                        { param_name: 'id', param_value: id }
                    ]
                });
            }}
            {...restProps}
        >
            {text}
        </DefaultMenuItem.Anchor>
    );
}
